/* ==================================================================
   CraftsBazaar · PDP Assurance / Trust block
   assets/cb-pdp-assurance.js
   ------------------------------------------------------------------
   Progressive enhancement only. Native <details> already works with
   JS disabled; this just adds a smooth height animation and keeps the
   chevron / state in sync. Safe to load with `defer`.
   ================================================================== */
(function () {
  'use strict';

  var DURATION = 320; // keep in sync with the CSS transition

  function prefersReducedMotion() {
    return window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function animateOpen(details, panel) {
    details.open = true; // reveal content first so we can measure it
    var target = panel.scrollHeight;
    panel.style.height = '0px';
    // force reflow so the browser registers the start height
    panel.getBoundingClientRect();
    panel.style.height = target + 'px';
    window.setTimeout(function () {
      // let it size to content afterwards (handles responsive reflow)
      if (details.open) panel.style.height = 'auto';
    }, DURATION);
  }

  function animateClose(details, panel) {
    var start = panel.scrollHeight;
    panel.style.height = start + 'px';
    panel.getBoundingClientRect(); // reflow
    panel.style.height = '0px';
    window.setTimeout(function () {
      details.open = false;
      panel.style.height = ''; // hand back to the CSS rule for closed state
    }, DURATION);
  }

  function enhanceItem(details) {
    if (details.dataset.cbEnhanced === 'true') return;
    details.dataset.cbEnhanced = 'true';

    var summary = details.querySelector('.cb-assure__summary');
    var panel = details.querySelector('.cb-assure__panel');
    if (!summary || !panel) return;

    // Items that start open should size to content immediately.
    if (details.open) panel.style.height = 'auto';

    summary.addEventListener('click', function (event) {
      if (prefersReducedMotion()) return; // let native toggle happen
      event.preventDefault();

      // Ignore clicks while a previous animation is mid-flight.
      if (details.dataset.cbAnimating === 'true') return;
      details.dataset.cbAnimating = 'true';
      window.setTimeout(function () { details.dataset.cbAnimating = 'false'; }, DURATION);

      if (details.open) {
        animateClose(details, panel);
      } else {
        animateOpen(details, panel);
      }
    });
  }

  function initRoot(root) {
    if (!root || root.dataset.cbInit === 'true') return;
    root.dataset.cbInit = 'true';
    root.classList.add('is-enhanced');
    var items = root.querySelectorAll('.cb-assure__item');
    for (var i = 0; i < items.length; i++) enhanceItem(items[i]);
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-cb-assure]');
    for (var i = 0; i < roots.length; i++) initRoot(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Re-init when the section is added/redrawn in the theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
